var map = {
	"./d1.jpg": 9132,
	"./d2.jpg": 4580,
	"./d3.jpg": 9969,
	"./d4.jpg": 6699,
	"./d5.jpg": 3105,
	"./d6.jpg": 9606,
	"./d7.jpg": 5230,
	"./d8.jpg": 5530,
	"./d9.jpg": 2000
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8933;